const LoanApplicationSkeleton = () => {
  return (
    <div className="w-full pl-[10px] pr-[40px] animate-pulse">
      <div className="flex items-center h-[60px] mb-[10px] justify-between">
        <div className="flex items-center gap-[5px]">
          <div className="w-[17px] h-[17px] bg-gray-300 rounded" />
          <div className="w-[60px] h-[16px] bg-gray-300 rounded" />
          <div className="w-[17px] h-[17px] bg-gray-300 rounded" />
          <div className="w-[140px] h-[16px] bg-gray-300 rounded" />
        </div>
        <div className="w-[240px] h-[40px] bg-gray-300 rounded-[30px]" />
      </div>

      <div className="flex items-center mb-[20px] gap-[30px]">
        {[1, 2, 3].map((_, i) => (
          <div key={i} className="w-[250px] h-[80px] bg-gray-200 rounded-lg" />
        ))}
      </div>

      <div className="h-[70px] w-full bg-white flex items-center justify-between px-[10px]">
        <div className="w-[117px] h-[40px] bg-gray-200 rounded-[10px]" />
        <div className="w-[117px] h-[40px] bg-gray-200 rounded-[10px]" />
        <div className="w-[127px] h-[40px] bg-gray-200 rounded-[10px]" />
        <div className="h-[40px] w-[40%] bg-gray-200 rounded-md" />
        <div className="w-[100px] h-[20px] bg-gray-200 rounded" />
        <div className="w-[117px] h-[40px] bg-gray-200 rounded-[30px]" />
        <div className="w-[120px] h-[40px] bg-gray-200 rounded-[30px]" />
      </div>

      <div className="mt-[10px] space-y-[7px]">
        <div className="h-[44px] px-[10px] w-full bg-[#F3F3F3] flex items-center">
          {[5, 14, 15, 14, 14, 14, 14, 14].map((width, idx) => (
            <div
              key={idx}
              className={`w-[${width}%] h-[16px] bg-gray-300 rounded`}
            />
          ))}
        </div>

        {[...Array(10)].map((_, i) => (
          <div
            key={i}
            className="h-[40px] cursor-pointer px-[10px] w-full bg-[#FFFFFF] flex items-center"
          >
            {[5, 14, 15, 14, 14, 14, 14, 14].map((width, idx) => (
              <div
                key={idx}
                className={`w-[${width}%] h-[14px] bg-gray-200 rounded`}
              />
            ))}
          </div>
        ))}
      </div>

      <div className="h-[50px] mb-[20px] flex items-center justify-between mt-4">
        <div className="flex items-center gap-[10px]">
          <div className="w-[80px] h-[15px] bg-gray-200 rounded" />
          <div className="w-[60px] h-[15px] bg-gray-200 rounded" />
          <div className="w-[40px] h-[15px] bg-gray-200 rounded" />
          <div className="w-[100px] h-[35px] bg-gray-200 rounded" />
        </div>
        <div className="w-[200px] h-[40px] bg-gray-200 rounded" />
      </div>
    </div>
  );
};

export default LoanApplicationSkeleton;
